
<el-tiptap
  :editorProperties="editorProperties"
  ref="editor"
  :extensions="extensions"
  :charCounterCount="false"
  :content="value"
  @onUpdate="onEditorUpdate"
  placeholder="Write a description..."
  @onBlur="blur"
/>
